import React from 'react';
import FieldGenerico from '../componentes_generales/componentes_formulario/fields/fieldgenerico';
import FieldDate from '../componentes_generales/componentes_formulario/fields/fielddate/fielddate';
import FieldSelect from '../componentes_generales/componentes_formulario/fields/fieldselect/fieldselect';
import FieldSelectAsync from '../componentes_generales/componentes_formulario/fields/fieldselect/fieldselectasync';
import FieldBusqEspecifica from '../componentes_generales/componentes_formulario/fields/busqueda_especifica/fieldselectasync-busq-especif';
import {Row, ContainerCol, ContenedorForm, HeaderForm, CuerpoForm, TituloForm } from '../componentes_generales/componentes_formulario/contenedores/';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { cargarCatalogos, cargarCatalogosGenericoAsync, cargarCatalogosAsync, cargarCatalogos_Otros } from '../../funciones_globales/catalogos';
import { connect } from 'react-redux';
import { cargar_proveedor, cargar_ValoresIniciales } from '../../actions/compras/act_comp01';
import styled from 'styled-components';
import global_axios from '../../funciones_globales/interaccionapi';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import ModalResponsive from '../componentes_generales/componentes_formulario/modals/modalresponsive';
import { validarFechaMomentEnFormatoString } from '../../funciones_globales/utils';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import { InputText } from '../componentes_generales/componentes_formulario/inputs/inputtext';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';
import moment from 'moment';
import { completar_String, formatearFechaMoment_a_String } from '../../funciones_globales/format';

import { SubmissionError } from 'redux-form';

const maxLength = max => value =>
    value && value.length > max ? `Hasta ${max} caracteres` : undefined;

const required = value => value ? undefined : 'Campo requerido';
const maxLength13 = maxLength(13);
const maxLength10 = maxLength(10);
const maxLength50 = maxLength(50);

const email = value =>
    value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ?
'Email inválido' : undefined;

const number = value => value && isNaN(Number(value)) ? 'Solo números' : undefined

const LabelRadio = styled.label`
    display: inline-block;
    font-weight: 600;
    font-size: 11px;
    margin-right: 10px;
    margin-top: 3px;
`;

const Label = styled.label`
    display: block;
    font-weight: 600;
    font-size: 11px;
    margin-bottom: 7px;
    margin-top: 6px;
`;

const ContainerEdit = styled.div`    
    border-bottom: 1px solid #cfd8dc;
    height: 70px;  
    padding: 10px;
    margin-bottom: 7px;
`;

const ModalContainer = styled.div`
    margin-top: 20px;
    height: 350px;
    width: 520px;
`;

const ContenedorModal = styled.div`
    margin-top: 20px;
    height: 75px;
    width: 550px;
`;

const Hr = styled.hr`
    margin-top: 10px;
    margin-bottom: 10px;
`;

class FormComp01 extends React.Component{   
    constructor(props) {
        super(props);
        this.state = {
            tipo_identificacion: [],
            tipo_empresa: [],
            tipo_proveedor: [],
            ret_iva_opt: [],
            ret_fte_opt: [],
            pais: [],
            //Willy
            tipo_proveedor_seteado:"B",
            //coleccion de datos para comparar y extraer el impuesto
            tabla_imp_iva: [],
            tabla_imp_rfe: [],

            //Estados
            operacion: 'G',
            cod_proveedor: '',
            plan: null,
            modalVisible: false,
            verCamposTransferencia: false,

            //Modal FormaPago
            isOpenFormaPago: false,
            dataModalFormaPago: [],
            optFechasPago: [],
            selectFecha_sel: null,
            cantidadDias: '',
            porcentaje: '',
            columnFormaPago:[  
                                {   header: "",
                                    field: "eliminar",
                                    width: 75,
                                    type: "link_elim"                                                
                                },
                                {   header: "Sec",
                                    field: "secuencia",
                                    width: 50,
                                    type: "string"
                                },
                                {   header: "Tipo",
                                    field: "tipo_fec",
                                    width: 50,
                                    type: "num_entero"
                                },  
                                {   header: "Descripción",
                                    field: "descripcion",
                                    width: 160,
                                    type: "string"                       
                                },                                    
                                {   header: "Dias plazo",
                                    field: "dias_plazo",
                                    width: 80,
                                    type: "num_entero_edit",
                                    editable: true                                            
                                },
                                {   header: "Porcentaje",
                                    field: "porcentaje",
                                    width: 80,
                                    type: "num_entero_edit",
                                    editable: true                                               
                                }                                                               
                            ],
        };

        this.formPagoOptions = {
            context: {
                componentParent: this
            },
            enableColResize: true,
            enableCellChangeFlash: true,
            onRowDataChanged:((event)=>{                
            }),
            onCellValueChanged:((event)=>{ 
                switch (event.colDef.field) {
                    case 'porcentaje':
                        if(event.newValue!==''){
                            let resp = 0;
                            let total = this.getTotalArticulo();
                            resp = (total*parseInt(event.data.porcentaje, 10))/100;
                            event.data.fob_base = resp.toFixed(2);
                        }else{
                            event.data.porcentaje = parseInt(event.oldValue,10);
                        }
                        
                        break;
                    case 'dias_plazo':
                        if(event.newValue!==''){
                            let fechaSumada;
                            let fecha = moment(event.data.fecha, 'DD/MM/YYYY')
                            fechaSumada = fecha.add(parseInt(event.data.dias_plazo, 10), 'days')
                            event.data.fecha_pago = formatearFechaMoment_a_String(fechaSumada)
                        }else{
                            event.data.dias_plazo = parseInt(event.oldValue,10);
                        }
                        break;
                
                    default:
                        break;
                }
                this.apiFormaPago.refreshCells(); 
            }),
            onCellEditingStarted:((event)=>{                
            })
        };

    this.actualizarCampos = this.actualizarCampos.bind(this);
    this.getOptions_Pais = this.getOptions_Pais.bind(this);
    this.getOptions_Ciudad = this.getOptions_Ciudad.bind(this);
    this.getOptions_CtaContable = this.getOptions_CtaContable.bind(this);
    this.getOptions_CtaAnticipo = this.getOptions_CtaAnticipo.bind(this);
    this.getOptions_CtaServicio = this.getOptions_CtaServicio.bind(this);
    this.inicializarComponentes = this.inicializarComponentes.bind(this);
    this.onChangeFormaPago = this.onChangeFormaPago.bind(this);
    this.toggleModalFormaPago = this.toggleModalFormaPago.bind(this);
    this.addFormaPago = this.addFormaPago.bind(this);

    //GRID
    this.onGridFormaPagoReady = this.onGridFormaPagoReady.bind(this);
    }  

    onGridFormaPagoReady(params) {
        this.apiFormaPago = params.api;
        this.columnApiFormaPago = params.columnApi;
    }

    getProveedor(){
        if(this.props.proveedor){
            let proveedorSelect = this.props.proveedor
            this.inicializarComponentes();
            this.setState({cod_proveedor: proveedorSelect.value})        
            this.setState({operacion: 'M'}, () => {
                this.props.cargar_Proveedor_a_editar(proveedorSelect.value).then(() => {
                    let array = [];
                    if(this.props.detPlanPago){
                        array = this.formatearFormasPago(this.props.detPlanPago)
                    }                    
                    this.setState({
                        dataModalFormaPago: array,
                        verCamposTransferencia: (this.props.FormaPago === "T")
                    });
                });
            });
        }else{
            alert('Seleccione un proveedor...')
        }        
    }

    formatearFormasPago(array){
        let dataFormaPago = [];
        if(array.length > 0){
            array.forEach((DET, i)=>{
                let item = {};
                item.secuencia = completar_String(i+1, '0', 3);
                item.tipo_fec = DET.CodTipoFecha;
                item.descripcion = DET.descFecha?DET.descFecha.Descripcion:'';
                item.dias_plazo = DET.DiasPlazo;
                item.porcentaje = DET.Porcentaje;
                dataFormaPago.push(item);
            })
        }
        return dataFormaPago;
    }

    getOptions_Proveedores(input, callback){
        if (input.toString().length >= 2 ){
            let cadena_busq = '&cadena_busq=' + input;
            cargarCatalogosGenericoAsync('/proveedores?tipo=catalogo', cadena_busq, callback)
        }
    }

    getOptions_Pais(input, callback){
        if (input.toString().length >= 2 ){
            cargarCatalogosAsync('PAIS', input, callback)
        }
    }

    getOptions_Ciudad(input, callback){
        if (input.toString().length >= 2 ){
            cargarCatalogosAsync('CIUDAD', input, callback)
        }
    }

    getOptions_Banco(input, callback){
        if (input.toString().length >= 2 ){
            cargarCatalogosAsync('BANCO', input, callback)
        }
    }

    getOptions_CtaContable(input, callback){
        if (input.toString().length >= 2 ){
            let cadena_busq = '?cadena_busq='+ input+'&plan='+this.state.plan.value.toString();
            cargarCatalogosGenericoAsync('/cuentas', cadena_busq, callback)
        }
    }

    getOptions_CtaAnticipo(input, callback){
        if (input.toString().length >= 2 ){
            let cadena_busq = '?cadena_busq='+ input+'&plan='+this.state.plan.value.toString();
            cargarCatalogosGenericoAsync('/cuentas', cadena_busq, callback)
        }
    }
    getOptions_CtaServicio(input, callback){
        if (input.toString().length >= 2 ){
            let cadena_busq = '?cadena_busq='+ input+'&plan='+this.state.plan.value.toString();
            cargarCatalogosGenericoAsync('/cuentas', cadena_busq, callback)
        }
    }

    getOptions_RubroImp(input, callback){
        if (input.toString().length >= 2 ){
            let cadena_busq = input;
            cargarCatalogosAsync('Retencion', cadena_busq, callback)
        }
    }

    onChangeFormaPago(value){
        this.setState({verCamposTransferencia: value})
    }

    guardarProveedor(data){ 
        let sendData = {};
        var ret_fte_p = null;
        var ret_iva_p = null;
        let proceder=true;
        let mensaje='';
        if(data.tipo_proveedor==='S'){
            if(data.cta_servicio!==undefined){
                if(data.cta_servicio.value===undefined){
                    mensaje='El campo Cta. Contable Servicio es requerido, porfavor seleccione una.'
                    proceder=false;
                }
            }else{
                mensaje='El campo Cta. Contable Servicio es requerido, porfavor seleccione una.'
                proceder=false;
            }
        }else if(data.tipo_proveedor==='B' || data.tipo_proveedor==='I'){
            if(data.cta_contable!==undefined){
                if(data.cta_contable.value===undefined){
                    mensaje='El campo Cta. Contable Bienes es requerido, porfavor seleccione una.'
                    proceder=false;
                }
            }else{
                mensaje='El campo Cta. Contable Bienes es requerido, porfavor seleccione una.'
                proceder=false;
            }
           
            
        }
        if(proceder){
            sendData.tipo_persona = data.tipo_persona;
            sendData.tipo_identificacion = data.tipo_identificacion;
            sendData.cedula = data.cedula;
            sendData.tipo_empresa=data.tipo_empresa;
    
            sendData.nombre=data.nombre?data.nombre.toUpperCase():'';
            sendData.razon_social=data.razon_social?data.razon_social.toUpperCase():'';
    
            sendData.domicilio = data.domicilio?data.domicilio.toUpperCase():'';
            sendData.telefono_1 = data.telefono_1?data.telefono_1:'';
            sendData.telefono_2 = data.telefono_2?data.telefono_2:'';
            sendData.pais = data.pais?data.pais.value:'';
            sendData.ciudad = data.ciudad?data.ciudad.value:'';
            
            sendData.num_bancaria = data.num_bancaria;
            sendData.proveedor_obra = data.proveedor_obra;
            sendData.relacionada = data.relacionada;
            sendData.contr_esp = data.contr_esp;
            sendData.tipo_proveedor = data.tipo_proveedor;
            
            sendData.correo = data.correo;
            sendData.contacto = data.contacto?data.contacto.toUpperCase():'';
            sendData.num_autorizacion = data.num_autorizacion;
            sendData.extranjero= data.extranjero;
            if(!data.fecha_autorizacion){
                sendData.fecha_autorizacion = null;
            }else{
                let valid =validarFechaMomentEnFormatoString(data.fecha_autorizacion)
                if(valid===false){
                    alert(' - El Formato de la fecha de autorización no es correcto')
                    return
                }else{
                    sendData.fecha_autorizacion = data.fecha_autorizacion;
                }
            }
            sendData.cta_contable = data.cta_contable?data.cta_contable.value:'';
            sendData.cta_anticipo = data.cta_anticipo?data.cta_anticipo.value:'';
            //Adicion de cuenta de servicio WILLY
            sendData.cta_servicio=  data.cta_servicio?data.cta_servicio.value:'';
    
            if(data.rubro_imp===undefined || data.rubro_imp===null){
                sendData.rubro_imp='';
            }else{
                sendData.rubro_imp = data.rubro_imp?data.rubro_imp.value:'';
            }
    
            if(!data.ret_iva){
                sendData.ret_iva = '';
            }else{
                this.state.tabla_imp_iva.forEach((IVA)=>{
                    if(IVA.Codigo === data.ret_iva){
                        ret_iva_p = IVA.Porcentaje;
                    }
                })
            }
    
            if(!data.ret_fte){
                sendData.ret_fte = '';
            }else{
                this.state.tabla_imp_rfe.forEach((IVA)=>{
                    if(IVA.Codigo === data.ret_fte){
                        ret_fte_p = IVA.Porcentaje;
                    }
                })
            }        
    
            sendData.ret_fte_p = ret_fte_p;
            sendData.ret_iva_p = ret_iva_p;
    
            sendData.ret_iva = data.ret_iva?data.ret_iva:null;
            sendData.ret_fte = data.ret_fte?data.ret_fte:null;
            sendData.ret_iva_servicio = data.ret_iva_servicio?data.ret_iva_servicio:null;
            sendData.ret_fte_servicio = data.ret_fte_servicio?data.ret_fte_servicio:null;
    
            //Validacion para adicion de plan pago Proveedor
            if(this.props.tipo_identificacion === 'P'){
                let acc = this.control_porcentaje_pago(this.state.dataModalFormaPago)
    
                if(acc<100){
                    alert("El porcentaje de pago es inferior al 100%");
                    throw new SubmissionError({ tipo_identificacion: 'Este tipo require ingresar formas de pago', _error: 'El porcentaje de pago es inferior al 100%' })
     
                }else if(acc>100){
                    alert("El porcentaje de pago es superior al 100%");
                    throw new SubmissionError({ tipo_identificacion: 'Este tipo require ingresar formas de pago', _error: 'El porcentaje de pago es inferior al 100%' })
                }else{
                    sendData.PlanPagoProveedor = this.state.dataModalFormaPago;
                }
            }
    
            sendData.DebitoBancario = data.DebitoBancario?data.DebitoBancario:null;
    
            //SECCION MODAL
            sendData.IdentificacionCash = data.IdentificacionCash?data.IdentificacionCash:null;
            sendData.FormaPago = data.FormaPago?data.FormaPago:null;
            sendData.TipoCuenta = data.TipoCuenta?data.TipoCuenta:null;
            sendData.Banco = data.Banco?data.Banco.value:null;
            sendData.CuentaBan = data.CuentaBan?data.CuentaBan:null;
    
            let config_request = {
                method: this.state.operacion==='G'? 'POST' : 'PATCH',
                url: this.state.operacion==='G'? '/proveedores':'/proveedores/'+ this.state.cod_proveedor,
                data: sendData
            };
    
            global_axios(config_request)
            .then((response)=> {
                if(this.state.operacion==='G'){
                    
                    alert('Registro #'+response.data.secuencia+' guardado con éxito');      
                }else{
                    alert('Registro #'+response.data.secuencia+' actualizado con éxito');      
                }
    
                this.inicializarComponentes();
            })
            .catch((error)=>{
                alert(error.response?error.response.data.msg:error.message);        
            })
        }else{
            alert(mensaje)
        }
    }
    setearTipoProveedor(e){
        if(e!==null && e!==undefined){
            let tipo_proveedor_seteado=e.value;
            this.setState({tipo_proveedor_seteado})
        }
    }
    submit(data){
        var proceder = false;
        var tipo = "";
        var valid = true;

        if(this.props.tipo_identificacion === 'P'){
            if(this.props.cedula === ""){
                valid = false;
            }
        }else{
            if(this.props.tipo_persona==='N'){
                tipo= 'CEDULA'
            }else if(this.props.tipo_persona==='J'){
                tipo= 'RUC'
            }
        } 
        
        if(tipo!==''){
            let config_request = {
                method: 'GET',
                url: '/verificador?tipo='+tipo+'&value=' + data.cedula
            };

            global_axios(config_request)
            .then((response)=> {
                
                if(response.data.resultado===0){
                    proceder = true;
                }else{
                    proceder = false;
                    alert("El número de "+tipo+" es inválido")
                }

                if(proceder===true){
                    this.guardarProveedor(data) 
                }
                
            })
            .catch((error)=>{
                alert(error.response?error.response.data.msg:error.message);       
            })
        }else
            if(tipo==='' && valid===true){
            this.guardarProveedor(data);
        }
        
        
    }

    cargarCatalogos_OtrosParametros(tipo) {
        return new Promise((resolve, reject) => {
            global_axios.get('/catalogos?tipo=otros&opcion=' + tipo)
            .then((response)=>{
                if(tipo==='COM-IMPIVA'){
                    this.setState({tabla_imp_iva: response.data})
                }else{
                    this.setState({tabla_imp_rfe: response.data})
                }
                resolve(response.data.map(item => ({value: item.Codigo.toString().toUpperCase(), label: `${item.Descripcion.toString().toUpperCase()} (${item.Codigo.toString().toUpperCase()})` })));
            })
            .catch((err)=>{
                reject('Error al cargar datos de catálogos desde API: ' + err);
            });
        });
    }
  
    componentDidMount(){
      Promise.all([
            cargarCatalogos_Otros('IMP-FECHAS'),          
            cargarCatalogos_Otros('COM-TIPOPROVEDOR'), this.cargarCatalogos_OtrosParametros('COM-IMPIVA'), this.cargarCatalogos_OtrosParametros('COM-IMPRTE'),
            cargarCatalogos('TIPOIDENT'), cargarCatalogos('TIPOEMP'), cargarCatalogos_Otros('GEN-PLANVIG'), generar_LogAuditoriaIngresoForm('0601'),
      ])
      .then(([r_tipofecha,result_tipopago,result_imp_IVA,result_imp_RTE,result_tipo_identificacion,result_tipo_empresa,result_planVigente]) => {
        this.setState({ optFechasPago: r_tipofecha, tipo_proveedor: result_tipopago, ret_iva_opt: result_imp_IVA, ret_fte_opt: result_imp_RTE,
        tipo_identificacion: result_tipo_identificacion, tipo_empresa: result_tipo_empresa, plan: result_planVigente[0]})
        this.props.cargar_ValoresIniciales();
        console.log(this.state.plan)
      })
      .catch((error)=>{
          alert('Error al cargar datos iniciales... ',error)
      })
    }

    componentWillMount(){
        console.log(this.props.handleSubmit(this.submit.bind(this)))
        
        this.props.generar_LogAuditoriaSalidaForm('0601');
    }
  
    inicializarComponentes(){
        this.props.reset();
        this.setState({operacion: 'G', dataModalFormaPago: [],tipo_proveedor_seteado:"B"});
        this.props.cargar_ValoresIniciales();
    }

    //ADICION DE FUNCIONALIDAD METODOS DE PAGO
    control_porcentaje_pago(arr){
        var acc=0;
        arr.forEach((data)=>{
            acc = acc + parseInt(data.porcentaje,10);
        })
        return acc;
    }

    toggleModalFormaPago(){
        this.setState({isOpenFormaPago: !this.state.isOpenFormaPago});
    }

    guardarFormaPago(){
        var acc=0;
        acc = (this.control_porcentaje_pago(this.state.data_modal_forma_pg))

        if(acc<100){
            alert("El porcentaje de pago es inferior al 100%");
        }else if(acc===100){
            let arrayEnvio = [];
            this.state.data_modal_forma_pg.forEach((det_pg)=>{
                var item = {};

                item.secuencia = this.props.detalle_forma_pago.length -1;
                item.tipo_fec = det_pg.tipo_fec
                item.descripcion = det_pg.descripcion
                item.fecha = det_pg.fecha
                item.dias_plazo = det_pg.dias_plazo
                item.porcentaje = parseInt(det_pg.porcentaje,10)
                item.fecha_pago = det_pg.fecha_pago
                item.fob_base = det_pg.fob_base
                item.valorcalculado = det_pg.valorcalculado
                item.estado = 'A'

                arrayEnvio.push(item);
            })

            let config_request = {
                method: 'POST',
                url: '/proveedores/' + this.state.codigo_importacion.toString()+ '/pagosimportacion' ,
                data: arrayEnvio
            };
                        
            global_axios(config_request)
            .then((response)=>{
                alert('La forma de pago se registró correctamente.');   
                this.setState({modFormaPago: null, revisarMetodosPago: false})     
            }) 
            .catch(function(error){                
                if (error.response){
                alert(error.response.data.msg);
                }
            })
        }else{
            alert("El porcentaje de pago es superior al 100%");
        } 
    }

    fixInputNumber(event){
        const target = event.target;       
        const name = target.name;    
        var value = target.value;

        if(value===''){
            value = 0;
        }

        this.setState({
          [name]: value
        });
    }

    actualizarCampos(event){
        const target = event.target;       
        const name = target.name;    
        const value = target.type === 'checkbox'? target.checked : target.value;
        this.setState({
          [name]: value
        });
    }

    immutablePush(array, newItem){
        return [ ...array, newItem ];  
    }

    immutableDelete (arr, index) {
        var i = parseInt(index, 10);
        return arr.slice(0,i).concat(arr.slice(i+1));
    }

    methodFromParent(id, datos_fila){

        let mensaje = window.confirm("¿Desea eliminar el registro?"); 
        if(mensaje){
            this.eliminarFormaPago(datos_fila ,id) 
        }
    }

    eliminarFormaPago(datos_fila ,id){        
        this.setState({dataModalFormaPago: this.immutableDelete(this.state.dataModalFormaPago, id)})
    }

    addFormaPago(){
        var acc=0;
        acc = this.control_porcentaje_pago(this.state.dataModalFormaPago);
        
        var porcentaje_pg = 0;
        porcentaje_pg = parseInt(this.state.porcentaje,10)

        var totalProcentajeIngreso = acc+porcentaje_pg
        if(acc>=100){
            alert("El porcentaje de pago ya cumple el 100%");
        }else if (this.state.selectFecha_sel === null){
            alert('Ud. no ha seleccionado el tipo de fecha a añadir.');
        }else if (parseInt(this.state.cantidadDias, 10)<0){    
            alert('Ud. no ha indicado la cantidad de dias referente al pago.');      
        }else if (totalProcentajeIngreso>100){ 
            alert('Ud. no ha indicado el porcentaje de pago o este excede el 100%.');
        }else{
            
            var subtotal = 0;
            var item_pago = {};

            this.state.dataModalFormaPago.forEach((item)=>{
                subtotal = item.subtotal + subtotal
            });

            item_pago.tipo_fec = parseInt(this.state.selectFecha_sel.value, 10)
            let index_final = this.state.dataModalFormaPago.length - 1;
            let nro_item = 0;

            if(index_final===-1){
                 nro_item = 1
            }else{
                nro_item = parseInt(this.state.dataModalFormaPago[index_final].secuencia, 10)+1;
            }

            item_pago.secuencia= completar_String(nro_item, '0', 3);
            item_pago.descripcion= parseInt(this.state.selectFecha_sel.value, 10)===1?"FECHA CONFIRMACIÓN":"FECHA EMBARQUE";
            item_pago.dias_plazo = parseInt(this.state.cantidadDias, 10);
            item_pago.porcentaje = parseInt(this.state.porcentaje, 10);
            item_pago.estado = 'A'
            
            this.setState({ dataModalFormaPago: this.immutablePush(this.state.dataModalFormaPago, item_pago)}
            ,()=>{
                this.limpiarControlesAddFormaPago();
            })
        }
    }

    limpiarControlesAddFormaPago(){
        this.setState({porcentaje: 0, cantidadDias: 0, selectFecha_sel: null})
    }

    falseFunction(){
    
    }
  
    render(){
          const { handleSubmit , submitting } = this.props
          return(
            <ContenedorForm porc_ancho={70}>
              <HeaderForm>
                <TituloForm>Proveedores</TituloForm>
              </HeaderForm>
              <CuerpoForm>
                <ContainerEdit>
                  <Row>
                    <div className='col-md-6'>
                      <Field
                        label="Cód. Proveedor:"
                        name="proveedor"
                        component={ FieldBusqEspecifica }                                  
                        loadOptions={this.getOptions_Proveedores.bind(this)}
                        getItemEspecifico={this.getProveedor.bind(this)}
                        func_OnFocus={this.inicializarComponentes}
                        textoBoton="Sel."
                        icono="fa fa-check-circle-o"/>
                    </div>
                  </Row>             
                </ContainerEdit>                                                                               
                <form onSubmit={handleSubmit(this.submit.bind(this))}>         
                    <Row>
                        <div className='col-md-2'>
                            <Label>Tipo persona:</Label>
                            <LabelRadio>
                                <Field
                                    name='tipo_persona'
                                    component='input'
                                    type="radio"
                                    value="N"
                                />{' '}Nat.
                            </LabelRadio >
                            <LabelRadio>
                                <Field
                                    name='tipo_persona'
                                    component='input'
                                    type="radio"
                                    value="J"
                                />{' '}Jur.
                            </LabelRadio>     
                        </div>
                        <div className='col-md-2'>
                            <Field
                                name="tipo_identificacion"
                                component= { FieldSelect }
                                label="Tipo identificación:"
                                validate={ required }
                                options={ this.state.tipo_identificacion }/>
                        </div>
                        <div className='col-md-2'>
                            <Field
                                name="cedula"
                                type="text"
                                component={ FieldGenerico }
                                label="Cédula/Ruc:"
                                placeholder="Cédula/Ruc/Pass"
                                validate={ [ (this.props.tipo_identificacion==='C'?maxLength10:this.props.tipo_identificacion==='R'?maxLength13:maxLength13), required, number] }
                                readonly={this.props.tipo_identificacion===undefined?true:false}/>
                        </div>
                        <div className='col-md-2 col-md-offset-4 col-md-pull-4'>
                            <Field
                                name="tipo_empresa"
                                component= { FieldSelect }
                                label="Tipo empresa:"
                                validate={ required }
                                options={ this.state.tipo_empresa }/>
                        </div>                                  
                    </Row>                
                    <Row>
                        <div className='col-md-6'>
                            <Field
                                name="nombre"
                                type="text"
                                validate={ required }
                                component={ FieldGenerico }
                                label="Nombre:"/>
                        </div>
                        <div className='col-md-6'>
                            <Field
                                name="razon_social"
                                type="text"
                                component={ FieldGenerico }
                                label="Razón social:"/>
                        </div>
                    </Row>
                    <Row>
                        <div className='col-md-3' >
                            <Field
                                name="domicilio"
                                type="text"
                                validate={[ required , maxLength50 ]}
                                component={ FieldGenerico }
                                label="Domicilio:"/>
                        </div>
                        <div className='col-md-2'>
                            <Field
                                name="telefono_1"
                                type="text"
                                component={ FieldGenerico }
                                label="Tlf.Celular:"
                                validate={[maxLength13, required, number]}
                                placeholder="09..."
                                />
                        </div>
                        <div className='col-md-2'>
                            <Field
                                name="telefono_2"
                                type="text"
                                component={ FieldGenerico }
                                label="Tlf.Convencional:"
                                placeholder="042..."
                                validate={ [maxLength13, number] }
                                />
                        </div>                  
                        <div className='col-md-2'>
                            <Field
                                label="País:"
                                name="pais"
                                validate={ required }
                                component={ FieldSelectAsync }                                   
                                loadOptions={this.getOptions_Pais}/>                                          
                        </div>
                        <div className='col-md-3'>
                            <Field
                                label="Ciudad:"
                                name="ciudad"
                                validate={ required }
                                component={ FieldSelectAsync }                                   
                                loadOptions={this.getOptions_Ciudad}
                            />                                          
                        </div>
                    </Row>
                    <Row>
                        <div className='col-md-3'>
                            <Field
                                name="num_bancaria"
                                type="text"
                                component={ FieldGenerico }
                                label="N° cta. bancaria:"/>
                        </div>
                        <div className='col-md-2'>
                            <Label>Proveedor obra</Label>
                            <LabelRadio>
                                <Field
                                    name='proveedor_obra'
                                    component='input'
                                    type="radio"
                                    value="S"
                                />{' '}Si
                            </LabelRadio >
                            <LabelRadio>
                                <Field
                                    name='proveedor_obra'
                                    component='input'
                                    type="radio"
                                    value="N"
                                />{' '}No
                            </LabelRadio>     
                        </div>
                        <div className='col-md-2'>
                            <Label>Emp. relacionada</Label>
                            <LabelRadio>
                                <Field
                                    name='relacionada'
                                    component='input'
                                    type="radio"
                                    value="SI"
                                />{' '}Si
                            </LabelRadio >
                            <LabelRadio>
                                <Field
                                    name='relacionada'
                                    component='input'
                                    type="radio"
                                    value="NO"
                                />{' '}No
                            </LabelRadio>     
                        </div> 
                        <div className='col-md-2'>
                            <Label>Contr. especial</Label>
                            <LabelRadio>
                                <Field
                                    name='contr_esp'
                                    component='input'
                                    type="radio"
                                    value="S"
                                />{' '}Si
                            </LabelRadio >
                            <LabelRadio>
                                <Field
                                    name='contr_esp'
                                    component='input'
                                    type="radio"
                                    value="N"
                                />{' '}No
                            </LabelRadio>     
                        </div>
                        <div className='col-md-3'>
                            <Field
                                name="tipo_proveedor"
                                component={ FieldSelect }
                                label="Tipo proveedor:"
                                validate={ required }
                                options={ this.state.tipo_proveedor}
                                onChange={ (value)=>{this.setearTipoProveedor(value)}} />
                        </div>
                    </Row>
                    <Row>
                        <div className='col-md-3'>
                            <Field
                                name="correo"
                                type="text"
                                validate={[required, email ]}
                                component={ FieldGenerico }
                                label="Correo:"/>
                        </div>
                        <div className='col-md-3'>
                            <Field
                                name="contacto"
                                type="text"
                                component={ FieldGenerico }
                                label="Contacto:"/>
                        </div>
                        <div className='col-md-3'>
                            <Field
                                name="num_autorizacion"
                                type="text"
                                component={ FieldGenerico }
                                validate={ number }
                                placeholder="0120..."
                                label="N° autorización:"/>
                        </div>
                        <div className='col-md-3'>
                            <Field
                                name="fecha_autorizacion"
                                component={ FieldDate }
                                label="Fecha caducidad:"                                
                                placeholder="dd/mm/aaaa"
                                />
                        </div>
                    </Row>             
                    <Row>
                        <div className='col-md-4'>
                            <Field
                                label="Cta. contable Bienes:"
                                name="cta_contable"
                                component={ FieldSelectAsync }                                   
                                loadOptions={this.getOptions_CtaContable}
                            />
                        </div>
                        <div className='col-md-4'>
                            <Field
                                label="Cta. contable servicio:"
                                name="cta_servicio"
                                component={ FieldSelectAsync }                                   
                                loadOptions={this.getOptions_CtaServicio}
                            />
                        </div> 

                        <div className='col-md-4'>
                            <Field
                                label="Cta. contable anticipo:"
                                name="cta_anticipo"
                                validate={ required }
                                component={ FieldSelectAsync }                                   
                                loadOptions={this.getOptions_CtaAnticipo}
                            />
                        </div> 
                        
                    </Row>
                    <Row>
                        <div className='col-md-4'>
                            <Field
                                name="ret_iva"
                                component= { FieldSelect }
                                label="Ret. iva bienes:"
                                //validate={ required }
                                options={ this.state.ret_iva_opt }/>
                        </div>
                        <div className='col-md-4'>
                            <Field
                                name="ret_fte"
                                component= { FieldSelect }
                                label="Ret. fte bienes:"
                                //validate={ required }
                                options={ this.state.ret_fte_opt }/>
                        </div>
                        <div className='col-md-4'>
                            <Field
                                label="Rubro:"
                                name="rubro_imp"
                                component={ FieldSelectAsync }                                 
                                loadOptions={this.getOptions_RubroImp}
                            />
                        </div>
                    </Row>
                    <Row>
                        <div className='col-md-4'>
                            <Field
                                name="ret_iva_servicio"
                                component= { FieldSelect }
                                label="Ret. iva servicios:"
                                //validate={ required }
                                options={ this.state.ret_iva_opt }/>
                        </div>
                        <div className='col-md-4'>
                            <Field
                                name="ret_fte_servicio"
                                component= { FieldSelect }
                                label="Ret. fte servicios:"
                                //validate={ required }
                                options={ this.state.ret_fte_opt }/>
                        </div>
                        <div className="col-sm-4">
                            <Label>Pago con débito bancario</Label>
                            <LabelRadio>
                                <Field
                                    name='DebitoBancario'
                                    component='input'
                                    type="radio"
                                    value="S"
                                />{' '}Si
                            </LabelRadio >
                            <LabelRadio>
                                <Field
                                    name='DebitoBancario'
                                    component='input'
                                    type="radio"
                                    value="N"
                                />{' '}No
                            </LabelRadio>     
                        </div>
                    </Row>
                    <Row>
                        
                        <div className="col-sm-4">
                            <Label>Extranjero</Label>
                            <LabelRadio>
                                <Field
                                    name='extranjero'
                                    component='input'
                                    type="radio"
                                    value="S"
                                />{' '}Si
                            </LabelRadio >
                            <LabelRadio>
                                <Field
                                    name='extranjero'
                                    component='input'
                                    type="radio"
                                    value="N"
                                />{' '}No
                            </LabelRadio>     
                        </div>
                        <div className="col-sm-4">
                            <button type="button" className="btn btn-default btn-sm" onClick={() => this.setState({modalVisible: true})}>
                                <i className="fa fa-external-link fa-fw"></i> Datos Cash Management
                            </button>
                        </div>
                    </Row>                   
                    <Row>
                        <div className='col-md-12'>
                            <div className="btn-group pull-right">
                                <button type="submit" className='btn btn-primary btn-sm' disabled={submitting}>
                                    <i className="fa fa-floppy-o fa-lg"></i> Guardar
                                </button>
                                <button type="button" className='btn btn-default btn-sm' onClick={this.inicializarComponentes}>
                                    <i className="fa fa-trash-o fa-lg"></i> Limpiar
                                </button>
                                <button type="button" className='btn btn-info btn-sm' disabled={this.props.tipo_identificacion==='P'?false:true} onClick={this.toggleModalFormaPago}>
                                    <i className="fa fa-credit-card-alt"></i> Forma de pago
                                </button>
                            </div>
                        </div>
                    </Row>
                    {/*MODAL CASH MANAGEMENT*/}
                    <ModalResponsive open={this.state.modalVisible} onClose={() => this.setState({modalVisible: false})}>
                        <ModalContainer>
                            <Row>
                                <ContainerCol className='col-sm-12'>
                                    <h4>Datos Cash Management</h4>
                                    <Hr />
                                </ContainerCol>
                            </Row>
                            <Row>
                                <ContainerCol className="col-sm-12">
                                    <Row>
                                        <ContainerCol className="col-sm-3">
                                            <Field
                                                name="IdentificacionCash"
                                                type="text"
                                                component={ FieldGenerico }
                                                label="Identificación Cash:"
                                                placeholder="Identificación"
                                                max='13'
                                                validate={ [ required, number] }
                                            />
                                        </ContainerCol>
                                    </Row>
                                    <Row>
                                        <ContainerCol className="col-sm-12">
                                            <Label>Forma de pago:</Label>
                                            <LabelRadio>
                                                <Field
                                                    name='FormaPago'
                                                    component='input'
                                                    type="radio"
                                                    value="O"
                                                    onChange={() => this.onChangeFormaPago(false)}
                                                />{' '}Otros
                                            </LabelRadio >
                                            <LabelRadio>
                                                <Field
                                                    name='FormaPago'
                                                    component='input'
                                                    type="radio"
                                                    value="E"
                                                    onChange={() => this.onChangeFormaPago(false)}
                                                />{' '}Efectivo
                                            </LabelRadio>
                                            <LabelRadio>
                                                <Field
                                                    name='FormaPago'
                                                    component='input'
                                                    type="radio"
                                                    value="C"
                                                    onChange={() => this.onChangeFormaPago(false)}
                                                />{' '}Cheque
                                            </LabelRadio>
                                            <LabelRadio>
                                                <Field
                                                    name='FormaPago'
                                                    component='input'
                                                    type="radio"
                                                    value="T"
                                                    onChange={() => this.onChangeFormaPago(true)}
                                                />{' '}Transferencia
                                            </LabelRadio>
                                            <Hr/>
                                        </ContainerCol>
                                    </Row>

                                    <Row isInvisible={!this.state.verCamposTransferencia}>
                                        <ContainerCol className="col-sm-12">
                                            <Label>Tipo de cuenta:</Label>
                                            <LabelRadio>
                                                <Field
                                                    name='TipoCuenta'
                                                    component='input'
                                                    type="radio"
                                                    value="C"
                                                />{' '}Corriente
                                            </LabelRadio >
                                            <LabelRadio>
                                                <Field
                                                    name='TipoCuenta'
                                                    component='input'
                                                    type="radio"
                                                    value="A"
                                                />{' '}Ahorros
                                            </LabelRadio>
                                        </ContainerCol>
                                    </Row>

                                    <Row isInvisible={!this.state.verCamposTransferencia}>
                                        <ContainerCol className="col-sm-4">
                                            <Field
                                                label="Banco:"
                                                name="Banco"
                                                validate={ required }
                                                component={ FieldSelectAsync }                                   
                                                loadOptions={this.getOptions_Banco}
                                                />    
                                        </ContainerCol>
                                        <ContainerCol className="col-sm-4">
                                            <Field
                                                name="CuentaBan"
                                                type="text"
                                                component={ FieldGenerico }
                                                label="Nro. Cuenta"
                                                placeholder="Nro. de cuenta"
                                                max='20'
                                                validate={ [ required, number] }
                                            />
                                        </ContainerCol>

                                        {/*<ContainerCol className="col-sm-4">
                                            <Field
                                                name="CuentaBanConfirm"
                                                type="text"
                                                component={ FieldGenerico }
                                                label="Confirmar Nro. Cuenta"
                                                placeholder="Confirmar Nro. de cuenta"
                                                validate={ [ data => this.props.CuentaBan!==data?undefined:'No son iguales', required, number] }
                                            />
                                        </ContainerCol>*/}
                                    </Row>
                                </ContainerCol>
                            </Row>
                            <Row>
                                <div className='col-sm-12'>
                                    <div className="btn-group pull-right">
                                        <button type='button' className='btn btn-success btn-sm' onClick={() => this.setState({modalVisible: false})}><i className='fa fa-check fa-fw'></i> Aceptar</button>                                                
                                    </div>
                                </div>
                            </Row>
                        </ModalContainer>
                    </ModalResponsive>

                    {/*MODAL FORMA DE PAGO*/}
                    <ModalResponsive open={this.state.isOpenFormaPago} ocultarClose={false} onClose={()=>{this.setState({isOpenFormaPago:false})}}>
                        <HeaderForm>
                            <TituloForm>Forma de pago</TituloForm>
                        </HeaderForm>
                        <CuerpoForm>
                            <ContenedorModal>
                                <Row>
                                    <ContainerCol className='col-sm-5'>
                                        <LabelForm>Tipo:</LabelForm>
                                        <ReactSelect options={ this.state.optFechasPago } value={this.state.selectFecha_sel} func_onChange={(value)=>{if(Array.isArray(value)){value=null};this.setState({selectFecha_sel: value})}}/>
                                    </ContainerCol>
                                    <ContainerCol className='col-sm-2'>
                                        <LabelForm>Dias:</LabelForm>
                                        <InputText name="cantidadDias" type="number" value={this.state.cantidadDias} onChange={this.actualizarCampos} maxLength="3" onBlur={(value)=>this.fixInputNumber(value)}/>
                                    </ContainerCol>
                                    <ContainerCol className='col-sm-2'>
                                        <LabelForm>Porcentaje:</LabelForm>
                                        <InputText name="porcentaje" type="number" value={this.state.porcentaje} onChange={this.actualizarCampos} maxLength="3" onBlur={(value)=>this.fixInputNumber(value)}/>
                                    </ContainerCol>
                                    <ContainerCol className='col-sm-1' margen_arriba="19">
                                        <button type="button" className='btn btn-success btn-sm' onClick={this.addFormaPago}><i className="fa fa-plus"></i></button>
                                    </ContainerCol>                                       
                                </Row>
                                <Row>
                                    <div className='col-md-12'>
                                        <AgGridRender altura='140px' data={this.state.dataModalFormaPago} columnas={this.state.columnFormaPago} gridOptions={this.formPagoOptions} onGridReady={this.onGridFormaPagoReady}/>                                                           
                                    </div>
                                </Row>
                                <Row>
                                    <div className='col-md-12'>
                                        <div className="btn-group pull-right">                                       
                                            <button type="button" className='btn btn-sm' /*disabled={this.state.dataModalFormaPago.length>0?false:true}*/ onClick={this.toggleModalFormaPago}>
                                                <i className="fa fa-times-circle"></i> Cerrar
                                            </button>                                                
                                        </div>                                     
                                    </div>
                                </Row>                              
                            </ContenedorModal>
                        </CuerpoForm>
                    </ModalResponsive>                   
                </form>
              </CuerpoForm>
            </ContenedorForm>
        );
    }
    
}

const selector = formValueSelector('form_comp01');


FormComp01 = reduxForm({
  form: 'form_comp01', enableReinitialize: true//, keepDirtyOnReinitialize: true
})(FormComp01);

FormComp01 = connect(
  state => ({
    initialValues: state.inicializacion_form.data,
    tipo_identificacion: selector(state, 'tipo_identificacion'),
    proveedor: selector(state, 'proveedor'),
    tipo_persona: selector(state, 'tipo_persona'),
    FormaPago: selector(state,"FormaPago"),
    CuentaBan: selector(state, "CuentaBan"),
    CuentaBanConfirm: selector(state, "CuentaBanConfirm"),
    detPlanPago: selector(state, 'detPlanPago')
  }),
  { cargar_Proveedor_a_editar: cargar_proveedor,
    cargar_ValoresIniciales, generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm }
)(FormComp01);

export default FormComp01;